import { getTimelineActivity } from 'api/activities';
import QueryKeys from 'api/queries/queryKeys';
import { format } from 'date-fns';
import { IActivity } from 'interfaces/activities';
import { TimelineQueryParams } from 'interfaces/queryParams';
import { IQueryRequest, ODataParamType } from 'interfaces/request';
import { DateRange } from 'react-day-picker';
import { useQuery } from 'react-query';

interface UseTimelineActivitiesParams extends TimelineQueryParams {
  dateRangeObject: DateRange | null;
}

function useTimelineActivities({
  params,
  options,
}: IQueryRequest<UseTimelineActivitiesParams>) {
  const { timelineId, dateRangeObject } = params;
  return useQuery({
    ...options,
    queryFn: async () => {
      let oDataQueryParams: ODataParamType[] = [];

      if (dateRangeObject?.from && dateRangeObject?.to) {
        oDataQueryParams = [
          {
            key: 'CreatedAt',
            operator: 'ge',
            value: dateRangeObject.from.toISOString(),
          },
          {
            key: 'CreatedAt',
            operator: 'lt',
            value: dateRangeObject.to.toISOString(),
          },
        ];
      }

      const { data } = await getTimelineActivity(
        timelineId,
        {
          page: 1,
          page_size: 1000,
        },
        oDataQueryParams
      );

      let formattedActivities: {
        [key: string]: IActivity[];
      } = {};

      const orderedArray = data.data.sort((prevActivity, nextActivity) => {
        if (prevActivity.time_stamp > nextActivity.time_stamp) return -1;
        if (prevActivity.time_stamp < nextActivity.time_stamp) return 1;
        return 0;
      });

      orderedArray.forEach((activity) => {
        const dateWithoutHours = format(
          new Date(activity.time_stamp),
          'dd.MM.yyyy'
        );

        const existingObject = formattedActivities[dateWithoutHours]
          ? formattedActivities[dateWithoutHours]
          : [];

        formattedActivities[dateWithoutHours] = [...existingObject, activity];
      });

      return formattedActivities;
    },
    queryKey: [QueryKeys.getTimelineActivities, timelineId, dateRangeObject],
  });
}

export default useTimelineActivities;
